module.exports = __webpack_public_path__ + "img/type(1).e8d2e8d5.png";